var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DIV",
    [
      _vm.value.invoice_kind === "outgoing"
        ? _c("span", [_vm._v("[V]")])
        : _vm._e(),
      _vm._v(" "),
      _vm.value.invoice_kind === "incoming"
        ? _c("span", [_vm._v("[S]")])
        : _vm._e(),
      _vm._v(" "),
      _c("strong", [_vm._v(_vm._s(_vm.value.invoice_number))]),
      _vm._v(" "),
      _c("UcInvoiceTypeBadge", {
        attrs: {
          value: _vm.value.invoice_type,
          kind: _vm.value.invoice_kind,
          advance: _vm.value.is_advance
        }
      }),
      _vm._v(" "),
      _vm.value.no_payment_required
        ? _c(
            "ItpBadge",
            {
              staticClass: "m-0",
              attrs: { variant: "warning", title: _vm.globs.noPaymentRequired }
            },
            [
              _c("iconify-icon", {
                attrs: { icon: "streamline:bill-cashless" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }